import Vue from 'vue'
import { YubikeyAuthMixinBody } from '@whitelist/wl-old-library/mixins/YubikeyAuthMixin'

export default Vue.extend(YubikeyAuthMixinBody)
